import endpoints from 'src/core/endpoints';
import { Platform } from 'src/types/constants';
import { UserStory } from 'src/types/epic';
import request from 'src/core/request';
import { Activity } from 'src/types/activity';
import {toast} from "react-toastify";

export const searchUserstories = async (reqData: { search: string }) => {
  // const project: Platform = JSON.parse(Cookies.get('platform') || '{}');
  const project: Platform = JSON.parse(localStorage.getItem('platform') || '{}');

  const { data } = await request.get(endpoints.userstories.search(reqData.search, project.id));

  return data as UserStory[];
};

export const getActivities = async (reqData: { id: number }) => {
  const { data } = await request.get(endpoints.userstories.activities(reqData.id));

  return data as Activity[];
};

export const getUserstories = async () => {
  // const project: Platform = JSON.parse(Cookies.get('platform') || '{}');
  const project: Platform = JSON.parse(localStorage.getItem('platform') || '{}');
  const data = await request.get(endpoints.userstories.list(project.id));
  return data.data;
};

export const updateUserstories = async (reqData: { id: number; userId: string; version: number }) => {
  try {
    const { data } = await request({
      url: endpoints.userstories.update(reqData.id),
      method: 'patch',
      data: {
        version: reqData.version,
        assigned_to: reqData.userId,
        assigned_users: [reqData.userId],
      },
    });
    return data;
  } catch (err: any) {
    toast.error('این کارت به شخص دیگری اختصاص داده شده است، لطفاً صفحه را رفرش کنید.');
    throw err;
  }
};

export const getReportForm = async () => {
  const data = await request.get(endpoints.report.forms());
  return data;
};
export const getReport = async (repData: { param: string; url: string }) => {
  const data = await request.get(endpoints.report.submit(repData.url, repData.param));
  return data;
};
